import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col } from 'antd';
import _ from 'lodash';
import RemoteSelect from './RemoteSelect';
import Modal from 'components/ui-ant/Feedback/modal';
import { isDefinedAndNotEmpty } from 'utils';

import '../../main/style.css';

const ManuelPackageModal = ({
  setAssignmentGroups,
  visible,
  onClose,
  stockLocations,
  packageOrder,
  onActionFire,
  actionData,
  getAllStockLocationsForMultipleSKUs,
  packageItemSet,
}) => {
  const [packageItems, setPackageItems] = useState([]);
  const [selectedPackageItems, setSelectedPackageItems] = useState([[]]);
  const [unselectedPackageItems, setUnselectedPackageItems] = useState([]);
  const [selectedStockLocations, setSelectedStockLocations] = useState([]);
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
  const [extraField, setExtraField] = useState([]);

  useEffect(() => {
    let packageDetail =
      isDefinedAndNotEmpty(packageOrder) &&
      !!Object.keys(packageOrder).length > 0
        ? packageOrder['packageItemSet'].map((item) => ({
            id: String(item.id),
            sku: item.orderItem.product.sku,
          }))
        : [];

    setPackageItems(
      (Object.keys(packageDetail).length > 0 &&
        packageDetail.map(({ id, sku }) => ({
          id,
          name: sku,
        }))) ||
        []
    );
  }, [packageOrder]);

  useEffect(() => {
    setUnselectedPackageItems(
      _.difference(
        packageItems.map((item) => String(item.id)),
        _.flatten(selectedPackageItems)
      )
    );
    setSelectedStockLocations(
      selectedStockLocations.slice(0, selectedPackageItems.length)
    );
  }, [selectedPackageItems]);

  useEffect(() => {
    let assignmentGroups = [];

    selectedPackageItems.forEach((items, index) => {
      assignmentGroups[index] = {
        package_items: [...items.map((item) => Number(item))],
        stock_location:
          Object.keys(selectedStockLocations).length > 0
            ? selectedStockLocations[index]
            : '',
      };
    });

    setAssignmentGroups(assignmentGroups);
    setExtraField(assignmentGroups);

    setSubmitButtonDisable(
      (isDefinedAndNotEmpty(selectedPackageItems) &&
        selectedPackageItems.length > 0 &&
        selectedPackageItems[0].length === 0) ||
        unselectedPackageItems.length > 0 ||
        selectedPackageItems.length !== selectedStockLocations.length
    );
  }, [selectedPackageItems, selectedStockLocations]);

  const handleChangeStockLocation = (index) => (value) => {
    const _selectedStockLocations = [...selectedStockLocations];

    _selectedStockLocations[index] = value;

    setSelectedStockLocations(_selectedStockLocations);
  };

  const handleChangePackageItem = (index, type) => (value) => {
    const _selectedPackageItems = [...selectedPackageItems];

    if (type === 'deselect') {
      _selectedPackageItems[index] =
        Object.keys(_selectedPackageItems).length > 0 &&
        _selectedPackageItems[index].filter((item) => item !== value);
    } else {
      _selectedPackageItems[index] = [
        ...(_selectedPackageItems[index] || []),
        value,
      ];
    }

    setSelectedPackageItems(_.reject(_selectedPackageItems, _.isEmpty));
  };

  const generateFields = (index) => (
    <div key={`field-group-${index}`}>
      <Row span={24}>
        <Col xs={24}>
          <span className='field-group-label'>
            {'Pakket'} {index + 1}
          </span>
        </Col>
      </Row>
      <Row span={24}>
        <Col xs={24}>
          <Form.Item label={'Sku'}>
            <RemoteSelect
              className='manuel-select'
              valueKeyName='id'
              labelKeyName='name'
              objectKey=''
              defaultValue={
                Object.keys(selectedPackageItems).length > 0
                  ? selectedPackageItems[index]
                  : []
              }
              dataSource={[...packageItems].filter(
                (item) =>
                  !_.flatten(
                    selectedPackageItems.filter((_, index2) => index !== index2)
                  ).includes(item.id)
              )}
              placeholder={'Selecteer sku'}
              onSelect={handleChangePackageItem(index)}
              onDeselect={handleChangePackageItem(index, 'deselect')}
              mode='multiple'
            />
          </Form.Item>
        </Col>
      </Row>
      <Row span={24}>
        <Col xs={24}>
          <Form.Item label={'Voorraad locatie'}>
            <RemoteSelect
              className='manuel-select'
              valueKeyName='erp_code'
              labelKeyName='name'
              searchParamName='name'
              objectKey=''
              defaultValue={
                Object.keys(selectedStockLocations).length > 0
                  ? selectedStockLocations[index]
                  : []
              }
              dataSource={[...stockLocations].filter(
                (item) =>
                  !_.flatten(
                    selectedStockLocations.filter(
                      (_, index2) => index !== index2
                    )
                  ).includes(item.id)
              )}
              idsParamName='id__in'
              placeholder={'Selecteer voorraadlocatie'}
              onChange={handleChangeStockLocation(index)}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );

  useEffect(() => {
    if (selectedPackageItems.length > 0) {
      const packSKUNumberList = packageItemSet
        .filter((packageItem_) => {
          return selectedPackageItems.some((selectedPackageItem) => {
            return selectedPackageItem.includes(String(packageItem_.id));
          });
        })
        .map((packageItem) => packageItem.orderItem.product.sku);

      const arrayToSearchQueries = packSKUNumberList.reduce(
        (acc, skuNumber) => {
          if (!skuNumber) return acc;
          acc += `&sku=${skuNumber}`;
          return acc;
        },
        ''
      );

      const isHaveSKU = arrayToSearchQueries.length > 0;
      if (isHaveSKU) {
        getAllStockLocationsForMultipleSKUs(arrayToSearchQueries);
      }
    }
  }, [selectedPackageItems]);

  return (
    <Modal
      width={700}
      className='manuel-package-modal'
      visible={visible}
      title={'Handmatige pakketplanning'}
      centered
      onCancel={onClose}
      footer={[
        <Button
          key='submit'
          type='primary'
          disabled={submitButtonDisable}
          onClick={() => onActionFire(actionData, extraField)}
        >
          {'Handmatige pakketplanning'}
        </Button>,
      ]}
    >
      {selectedPackageItems.map((item, index) => generateFields(index))}
      {unselectedPackageItems.length > 0 &&
        generateFields(selectedPackageItems.length)}
    </Modal>
  );
};

export default ManuelPackageModal;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/manuelPackage/index.js